import {
  getCommonResource,
  postCommonResource,
  putCommonResource,
} from "../../api/common";
import { createSliceWithThunks } from "../utils";

const initialState = {
  snackbar: {
    open: false,
    timeout: 3000,
    message: "",
    type: "info",
  },
  genres: {
    list: null,
    error: null,
    status: "idle",
  },
  post: {
    data: null,
    error: null,
    status: "idle",
  },
  put: {
    data: null,
    error: null,
    status: "idle",
  },
};

export const commonSlice = createSliceWithThunks({
  name: "commonSlice",
  initialState: initialState,
  reducers: (create) => ({
    resetStateCommon: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    showSnackbar: create.reducer((state, { payload }) => {
      state.snackbar = { ...state.snackbar, ...payload };
    }),
    hideSnackbar: create.reducer((state) => {
      state.snackbar.open = false;
    }),
    addCommonResource: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postCommonResource(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.post.status = "loading";
        },
        rejected: (state, action) => {
          state.post.status = "failed";
          state.post.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.post.error = { message: respObj };
            } else if (status === "success") {
              state.post.data = respObj;
            }
          } else {
            state.post.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.post.status = "idle";
        },
      }
    ),
    updateCommonResource: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await putCommonResource(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.put.status = "loading";
        },
        rejected: (state, action) => {
          state.put.status = "failed";
          state.put.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.put.error = { message: respObj };
            } else if (status === "success") {
              state.put.data = respObj;
            }
          } else {
            state.put.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.put.status = "idle";
        },
      }
    ),
    fetchGenres: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getCommonResource(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.genres.status = "loading";
        },
        rejected: (state, action) => {
          state.genres.status = "failed";
          state.genres.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            let { status, data: respObj } = data;
            if (status === "error") {
              state.genres.error = { message: respObj };
            } else if (status === "success") {
              state.genres.list = respObj;
            }
          } else {
            state.genres.error = {
              message: data?.message || "An error occurred",
            };
          }
          state.genres.status = "idle";
        },
      }
    ),
  }),
});

export const {
  showSnackbar,
  hideSnackbar,
  fetchGenres,
  resetStateCommon,
  addCommonResource,
  updateCommonResource,
} = commonSlice.actions;
export default commonSlice.reducer;
